import { PebbleResolver } from "../SportsbookPlacePanel.types";

type OrderableResolvers = {
  singles: PebbleResolver;
  betBuilder: PebbleResolver;
  multiples: PebbleResolver;
  castBet: PebbleResolver;
};

export function getOrderedPebblesResolvers(resolvers: OrderableResolvers, isSinglesFirst?: boolean): PebbleResolver[] {
  const { singles, betBuilder, multiples, castBet } = resolvers;

  const nonSinglesPebbles = [betBuilder, multiples, castBet];

  return isSinglesFirst ? [singles, ...nonSinglesPebbles] : [...nonSinglesPebbles, singles];
}
